module.exports = __webpack_public_path__ + "static/media/16-4.828e9203.mp3";